import { GuidanceStepperExample } from "../../../../../../packages/design-system/src/GuidanceStepper/readme-helpers";
import * as React from 'react';
export default {
  GuidanceStepperExample,
  React
};